export default __webpack_public_path__ + "static/media/error-icon.3888f749.svg";